export const QUERY_KEYS = {
    IS_WEB_VIEW: 'is-web-view',
};

export const J_SESSION_ID = 'JSESSIONID';
export const WEB_VIEW_SESSION_ID = 'WEBVIEWSESSIONID';

export const IS_WEB_VIEW_QUERY_PARAM = 'isWebView';
